import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sid = params.get("session_id");
    if (!sid) { nav("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google-session", { session_id: sid });
        setUser(data);
        window.history.replaceState(null, "", "/dashboard");
        nav("/dashboard", { state: { user: data } });
      } catch (e) {
        toast.error("Google sign-in failed");
        nav("/login");
      }
    })();
  }, [location.hash, nav, setUser]);

  return (
    <div className="min-h-screen bg-[#09090B] text-zinc-400 flex items-center justify-center font-adult-mono text-sm">
      Finishing sign-in…
    </div>
  );
}
